import { createFeatureSelector, createSelector } from "@ngrx/store";
import { TripManageState } from "./reducers-trip";

/**
 * Top level selector for the TripManageState
 */
export const tripManageState = createFeatureSelector<TripManageState>('tripsManage');

export const getFoundTrips = createSelector(
    tripManageState,
    (state: TripManageState) => state.entityData
);

export const getTripToEdit = createSelector(
    tripManageState,
    (state: TripManageState) => state.editEntityData
);

export const getTripToView = createSelector(
    tripManageState,
    (state: TripManageState) => state.viewEntityData
);

export const getTripCopyMode = createSelector(
    tripManageState,
    (state: TripManageState) => state.isCopy
);